"use client";

import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const faqs = [{
  question: "How quickly can care start for my loved one?",
  answer: "We can often arrange an initial assessment within 24 to 48 hours. Our team works efficiently to ensure that compassionate care begins as soon as your family needs it."
}, {
  question: "Are your carers fully insured and CQC-registered?",
  answer: "Yes, Cynthylee Health Care is a CQC-registered provider. All our caregivers are fully insured, undergo rigorous DBS checks, and receive ongoing professional training to maintain our premium standards."
}, {
  question: "Do you provide care during nights and weekends?",
  answer: "Absolutely. We offer 24/7 support, including overnight care and weekend assistance, ensuring your loved ones are never without the professional help they deserve in Brighton & Hove."
}, {
  question: "Can I change the level of care as needs evolve?",
  answer: "Care plans are flexible and reviewed regularly. Whether you need to increase hours for respite care or transition to live-in support, we adapt our services to match your family's changing requirements."
}, {
  question: "How do you match caregivers with clients?",
  answer: "We take great pride in our matching process, considering not just clinical needs but also personality, interests, and language to ensure a harmonious and trusting relationship."
}];
export default function FrequentlyAskedQuestions() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="221941" id="frequently-asked-questions" className="bg-background text-foreground py-20 px-6 md:px-12 lg:px-24 overflow-hidden">
      <div ref={ref} className={`max-w-4xl mx-auto transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <div className="text-center mb-12">
          <h2 className="font-default text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight mb-4 text-foreground">
            Frequently Asked Questions
          </h2>
          <p className="text-muted-foreground text-lg max-w-2xl mx-auto font-default">
            Find answers to common questions about our premium home care services and our commitment to your family's well-being.
          </p>
        </div>

        <div className="bg-card rounded-2xl p-6 md:p-10 shadow-xl border border-border/60">
          <Accordion type="single" collapsible className="w-full">
            {faqs.map((faq, i) => <AccordionItem key={i} value={`item-${i}`} data-index={i} className="border-border/60">
                <AccordionTrigger className="font-default font-semibold text-lg md:text-xl text-left text-primary hover:text-primary/80 transition-colors hover:no-underline py-6">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground text-base md:text-lg leading-relaxed pb-6 font-default">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>)}
          </Accordion>
        </div>
      </div>
    </section>;
}